import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-auto p-10 pt-4 flex flex-col gap-2" }

import type { CardProps } from "./CardProps";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Image from "@/views/blocks/shared/section/image/Image.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import EditableElement from "@/views/page/EditableElement.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    fieldPrefix: {},
    blockId: {},
    image: {},
    tag: {},
    title: {},
    description: {},
    tagTextColor: {},
    titleTextColor: {},
    descriptionTextColor: {},
    backgroundColor: {},
    borderColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "border-2 flex flex-col overflow-hidden",
    style: _normalizeStyle({ backgroundColor: _ctx.backgroundColor, borderColor: _ctx.borderColor })
  }, [
    (!_ctx.image.isHidden)
      ? (_openBlock(), _createBlock(EditableElement, {
          key: 0,
          blockId: _ctx.blockId,
          "field-name": `${_ctx.fieldPrefix}Image`
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              src: _ctx.image.data.src,
              alt: _ctx.image.data.alt,
              class: "w-full object-cover",
              width: "600",
              height: "320"
            }, null, 8, ["src", "alt"])
          ]),
          _: 1
        }, 8, ["blockId", "field-name"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.tag.isHidden)
        ? (_openBlock(), _createBlock(EditableElement, {
            key: 0,
            blockId: _ctx.blockId,
            "field-name": `${_ctx.fieldPrefix}Tag`
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                style: _normalizeStyle({ color: _ctx.tagTextColor }),
                class: "text-sm font-semibold"
              }, _toDisplayString(_ctx.tag.data.text), 5)
            ]),
            _: 1
          }, 8, ["blockId", "field-name"]))
        : _createCommentVNode("", true),
      (!_ctx.title.isHidden)
        ? (_openBlock(), _createBlock(EditableElement, {
            key: 1,
            blockId: _ctx.blockId,
            "field-name": `${_ctx.fieldPrefix}Title`
          }, {
            default: _withCtx(() => [
              _createVNode(Heading, {
                text: _ctx.title.data.text,
                textColor: _ctx.titleTextColor,
                tag: _ctx.title.data.tag,
                class: "text-lg"
              }, null, 8, ["text", "textColor", "tag"])
            ]),
            _: 1
          }, 8, ["blockId", "field-name"]))
        : _createCommentVNode("", true),
      (!_ctx.description.isHidden)
        ? (_openBlock(), _createBlock(EditableElement, {
            key: 2,
            blockId: _ctx.blockId,
            "field-name": `${_ctx.fieldPrefix}Description`
          }, {
            default: _withCtx(() => [
              _createVNode(Paragraph, {
                text: _ctx.description.data.text,
                textColor: _ctx.descriptionTextColor,
                class: "text-sm/6 opacity-80"
              }, null, 8, ["text", "textColor"])
            ]),
            _: 1
          }, 8, ["blockId", "field-name"]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})